<template>
  <div class="grid grid--wide">
    <div class="xs-12">
      <div class="myhome-header__buttons">
        <div class="myhome-header__buttons--left">
          <slot name="button-left"></slot>
        </div>
        <div class="myhome-header__buttons--right">
          <slot name="button-right"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeHeaderButtons",
  props: {
    linkColor: {
      type: String,
      default: "",
    },
    role: {
      type: String,
      default: "ROLE_TEACHER",
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.myhome-header__button {
  align-items: center;
  border: $border-bold $dea-color-grey-light;
  border-radius: $border-radius-large;
  display: flex;
  height: 100%;
  justify-content: space-between;
  padding: $space-base;
}

.myhome-header__buttons {
  @include media("<=m") {
    flex-wrap: wrap;
  }

  display: flex;
  margin-bottom: $space-base;
  margin-top: $space-base;
  width: 100%;

  &--left,
  &--right {
    @include media("<=m") {
      flex-wrap: wrap;
      width: 100%;
    }

    width: 50%;

    h3 {
      margin: 0;
    }

    .dea-button {
      @include media("<=xs") {
        margin-top: $space-small;
      }
    }
  }

  &--right {
    @include media("<=l") {
      margin-left: $space-large;
    }

    @include media("<=m") {
      margin-left: 0;
      margin-top: $space-base;
    }
    margin-left: $space-base;
  }
}
</style>
